// Vector tiles
export const getHereVectorTileUrl = (apiKey: string): string =>
  `https://vector.hereapi.com/v2/vectortiles/base/mc/{z}/{x}/{y}/omv?apikey=${apiKey}`

export const getHereVectorTrafficTileUrl = (apiKey: string): string =>
  `https://traffic.vector.hereapi.com/v2/traffictiles/traffic/mc/{z}/{x}/{y}/omv?apikey=${apiKey}`

// Raster tiles
export const getHereRasterTileUrl = (apiKey: string): string =>
  `https://maps.hereapi.com/v3/base/mc/{z}/{x}/{y}/png8?lang=en&ppi=400&features=pois:disabled&size=512&apiKey=${apiKey}`

export const getHereRasterGreyTileUrl = (apiKey: string): string =>
  `https://maps.hereapi.com/v3/base/mc/{z}/{x}/{y}/png8?lang=en&ppi=400&features=pois:disabled&size=512&style=lite.day&apiKey=${apiKey}`

export const getHereRasterNightTileUrl = (apiKey: string): string =>
  `https://maps.hereapi.com/v3/base/mc/{z}/{x}/{y}/png8?lang=en&ppi=400&features=pois:disabled&size=512&style=explore.night&apiKey=${apiKey}`

export const getHereSatelliteTileUrl = (apiKey: string): string =>
  `https://maps.hereapi.com/v3/base/mc/{z}/{x}/{y}/png8?lang=en&ppi=400&features=pois:disabled&size=512&style=explore.satellite.day&apiKey=${apiKey}`

export const getHereRasterTrafficTileUrl = (apiKey: string): string =>
  `https://traffic.maps.hereapi.com/v3/flow/mc/{z}/{x}/{y}/png8?ppi=400&size=512&apiKey=${apiKey}`
